import { servicesA } from "./servicesA";
import { servicesB } from "./servicesB";
import { servicesC } from "./servicesC";

export const CATEGORIES = [
  { id: "property", label: "Property & Boundary", code: "A" },
  { id: "topo", label: "Topographic & Terrain", code: "B" },
  { id: "construction", label: "Construction & As-Built", code: "C" },
  { id: "roads", label: "Roads, Routes & Infrastructure", code: "D" },
  { id: "utilities", label: "Utilities & Drainage", code: "E" },
  { id: "development", label: "Land Development", code: "F" },
  { id: "specialized", label: "Specialized & Digital", code: "G" },
];

export const SERVICES = [...servicesA, ...servicesB, ...servicesC];
export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label ?? "";

export const relatedFor = (s) => {
  const ids = s.rel?.length ? s.rel : SERVICES.filter((x) => x.cat === s.cat && x.slug !== s.slug).map((x) => x.slug);
  return ids.map(getService).filter(Boolean).slice(0, 4);
};

export const QA_STEPS = [
  "Input check: completeness, coordinate system and code consistency",
  "Drafting against your standards or our structured default template",
  "Independent review of linework, labels and annotation",
  "Cross-check of drawing values against the supplied data",
  "Final plot and file check before delivery",
];

export const HOME_CARDS = [
  ["Boundary & Property Surveys", "boundary-survey-drafting", "boundary"],
  ["ALTA/NSPS Land Title Surveys", "alta-nsps-survey-drafting", "alta"],
  ["Topographic & Contour Surveys", "topographic-survey-drafting", "topo"],
  ["As-Built Surveys", "as-built-survey-drafting", "asbuilt"],
  ["Subdivision & Parcel Surveys", "subdivision-plat-drafting", "subdivision"],
  ["Mortgage Location Surveys", "mortgage-location-survey-drafting", "boundary"],
  ["Utility & Drainage Surveys", "utility-survey-drafting", "utility"],
  ["Construction & Staking Drafting", "construction-staking-drafting", "construction"],
  ["Right-of-Way & Route Surveys", "right-of-way-survey-drafting", "route"],
  ["Land Development Surveys", "land-development-survey-drafting", "subdivision"],
  ["Elevation & Grading Surveys", "elevation-survey-drafting", "elevation"],
  ["Roadway & Corridor Surveys", "roadway-survey-drafting", "route"],
  ["Tree & Feature Surveys", "tree-survey-drafting", "tree"],
  ["Hydrographic & Mining Drafting", "hydrographic-survey-drafting", "hydro"],
  ["Drone & UAV Mapping", "drone-uav-survey-mapping", "drone"],
  ["Point Cloud & Laser Scanning to CAD", "point-cloud-to-cad", "pointcloud"],
  ["GIS Survey Mapping", "gis-survey-mapping", "gis"],
  ["Survey Data Conversion & Redrafting", "survey-data-to-cad-conversion", "conversion"],
];

// ---- SEO keyword sets per service type ----
const CAT_KEYWORDS = {
  property: ["land survey CAD drafting", "boundary survey drafting", "property line survey drawings", "ALTA/NSPS land title survey drafting", "cadastral mapping services", "plot plan drafting", "easement and right-of-way mapping"],
  topo: ["topographic survey CAD drafting", "contour mapping and drafting", "elevation survey drawings", "spot level mapping", "digital terrain model (DTM) drafting", "existing ground level plans", "surface model creation"],
  construction: ["construction survey CAD drafting", "setting-out survey drawings", "site layout plan drafting", "as-built survey drafting", "building footprint mapping", "construction as-built drawings"],
  roads: ["road and highway survey CAD", "highway alignment drawings", "bridge survey drafting", "rail survey CAD services", "route survey drafting", "right-of-way mapping"],
  utilities: ["utility survey CAD drafting", "underground utility mapping", "as-built utility drawings", "stormwater drainage mapping", "manhole and drainage plans", "utility record digitization"],
  development: ["subdivision survey drawings", "plot plan drafting", "grading plan drafting", "site plan drafting for surveyors", "land development CAD drafting", "lot layout drafting"],
  specialized: ["point cloud to CAD conversion", "scan-to-CAD drafting services", "drone survey CAD drafting", "LiDAR survey data processing", "GIS data conversion", "PDF to DWG conversion", "survey data processing services"],
};
const GLOBAL_KEYWORDS = ["survey CAD drafting services", "CAD drafting for surveyors", "outsourced survey CAD services", "survey drawing services"];

export const keywordsFor = (s) => {
  const base = s.title.replace(/ Drafting$| Services$/i, "");
  const own = [`${base} drafting services`, `${base} CAD drafting`, `${base} drawings`, `outsource ${base.toLowerCase()} drafting`, `${base.toLowerCase()} CAD services for surveyors`];
  return [...new Set([...own, ...(CAT_KEYWORDS[s.cat] || []), ...GLOBAL_KEYWORDS])].slice(0, 14);
};
